// eslint-disable-next-line
import React, { useEffect } from 'react';
import { IconButton, Paper, List, ListItem, ListItemText, Typography } from '@mui/material';
import { GetApp } from '@mui/icons-material';
import { GenericToolbar } from '../../components/GenericToolbar';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ContentContainer } from '../../components/ContentContainer';
import { useDispatch, useSelector } from 'react-redux';
import { HelpAndFeedback } from '../enum/ENUM';
import { DownloadDocumentThunks } from '../../actions/thunks/download-document-thunks';
import { Selectors } from '../../selectors';
import Downloading from '../../components/Downloading/Downloading';
import { useSnackbar } from '../../providers/SnackBarProvider';
import { getLanguageList } from '../../components/UserDetails/AccountPreferencesData';
import { SessionStorage } from '../../components/AuthContextProvider/session-storage';

export const HelpFeedback: React.FC<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = () => {
    const { t } = useLanguageLocale();
    const dispatch = useDispatch();
    const { success, error } = useSnackbar();
    const documentDownload = useSelector(Selectors.DocumentDownload.documentdownload);
    const languageKey = getLanguageList(SessionStorage.readLanguage()).key
   
    const handleDownload = () => {
        if (!documentDownload.downloadDocumentLoading) {
            dispatch(DownloadDocumentThunks.downloadDocument(HelpAndFeedback.Installation_Manual, languageKey));
        }
    }

    useEffect(() => {
        const { downloadDocumentLoading, downloadDocumentData, downloadDocumentErrorMessage } = documentDownload;
        if (!downloadDocumentLoading) {
            if (downloadDocumentData?.ok) {
                success(t('INSTALLATION_MANUAL.DOWNLOAD_SUCCESSFULLY'))
            } else if (downloadDocumentErrorMessage) {
                error(t('INSTALLATION_MANUAL.DOWNLOAD_FAILED'))
            }
        }
    }, [documentDownload]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <GenericToolbar title={t('DRAWER.HELPANDFEEDBACK')} />

            <Typography data-testid="manuals" style={{ fontWeight: 400, fontSize: 34, paddingLeft: '8%', paddingTop: '2%' }}>
                {t('HELPANDFEEDBACK.MANUALS')}
            </Typography>

            <ContentContainer>
                <Paper>
                    <div>
                        <List className="list" disablePadding data-testid="download-document-menu">
                            <ListItem
                                data-testid="download-document"
                                className="selected"
                                divider={true}
                                style={{ height: 72, cursor: 'pointer' }}
                                onClick={handleDownload}
                            >
                                <ListItemText
                                    primary={t('HELPANDFEEDBACK.TITLE')}
                                    primaryTypographyProps={{
                                        variant: 'body1',
                                        style: { fontWeight: 600 },
                                    }}
                                ></ListItemText>
                                {
                                    documentDownload.downloadDocumentLoading ?
                                        <Downloading size='medium' /> :
                                        <IconButton>
                                            <GetApp id="download-document-icon" data-testid="download-document-icon" />
                                        </IconButton>
                                }
                            </ListItem>
                        </List>
                    </div>
                </Paper>
            </ContentContainer>
        </>
    );
};